<template>
  <div class="w-full">
    <Carousel
      :value="bookmakers"
      :numVisible="5"
      :numScroll="1"
      circular
      :autoplayInterval="5000"
      :responsiveOptions="responsiveOptions"
      :showIndicators="false"
      :showNavigators="false"
      class="w-full"
    >
      <template #item="slotProps">
        <div class="px-1 sm:px-1 md:px-2">
          <div class="relative mx-auto border border-white rounded overflow-hidden">
            <img
              :src="staticBaseUrl + slotProps.data.id + '/banner.png'"
              :alt="slotProps.data.name"
              class="w-full h-auto object-contain"
            />
          </div>
        </div>
      </template>
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import Carousel from 'primevue/carousel'
import type { CarouselResponsiveOptions } from 'primevue/carousel'

function shuffle(array: any[]): any[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

const staticBaseUrl = window.__APP_CONFIG__.STATIC_BASE_URL

const bookmakers = shuffle([
  {
    id: '888sport',
    name: '888 Sport',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'betmgm',
    name: 'BetMGM',
    linkable: true,
    betBuilder: true,
  },
  {
    id: 'betrivers',
    name: 'Bet Rivers',
    linkable: true,
    betBuilder: true,
  },
  {
    id: 'betvictor',
    name: 'Bet Victor',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'betway',
    name: 'Betway',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'boylesports',
    name: 'Boylesports',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'coral',
    name: 'Coral',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'draftkings',
    name: 'Draftkings',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'fanduel',
    name: 'Fanduel',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'ladbrokes',
    name: 'Ladbrokes',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'leovegas',
    name: 'Leovegas',
    linkable: true,
    betBuilder: true,
  },
  {
    id: 'paddypower',
    name: 'Paddy Power',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'pointsbet',
    name: 'Points Bet',
    linkable: false,
    betBuilder: false,
  },
  {
    id: 'skybet',
    name: 'Skybet',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'unibet',
    name: 'Unibet',
    linkable: false,
    betBuilder: true,
  },
  {
    id: 'virginbet',
    name: 'Virgin Bet',
    linkable: true,
    betBuilder: false,
  },
  {
    id: 'williamhill',
    name: 'William Hill',
    linkable: true,
    betBuilder: false,
  },
])

const responsiveOptions: CarouselResponsiveOptions[] = [
  { breakpoint: '1024px', numVisible: 4, numScroll: 1 },
  { breakpoint: '640px', numVisible: 3, numScroll: 1 },
]
</script>
